module.exports = {
      id: "app-gallery-usage",
      viewBox: "0 0 161 48",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#app-gallery",
      toString: function () {
        return this.url;
      }
    }